@if (isOpen) {
  <div
    class="fixed inset-0 z-[99999] flex items-center justify-center bg-black/[0.32] dark:bg-black/60 p-6"
  >
    <div
      animate.enter="enter-animation"
      class="flex flex-col gap-6 min-w-[17.5rem] max-w-[32.5rem] rounded-3xl p-6 bg-white text-gray-900 dark:bg-gray-800 dark:text-gray-100 shadow-black/20 border-t-4"
      [class.border-green-500]="dialogData.variant === 'success'"
      [class.border-red-500]="dialogData.variant === 'error'"
      [class.border-blue-500]="
        !dialogData.variant || dialogData.variant === 'info'
      "
    >
      <!-- Text -->
      <div class="flex flex-col gap-4">
        @if (dialogData.title) {
          <div class="flex items-center gap-2">
            @if (dialogData.variant === "success") {
              <svg
                class="w-6 h-6 text-green-500"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            } @else if (dialogData.variant === "error") {
              <svg
                class="w-6 h-6 text-red-500"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
                />
              </svg>
            }
            <h3
              class="text-lg font-semibold tracking-tight"
              [class.text-green-700]="dialogData.variant === 'success'"
              [class.dark:text-green-400]="dialogData.variant === 'success'"
              [class.text-red-700]="dialogData.variant === 'error'"
              [class.dark:text-red-400]="dialogData.variant === 'error'"
            >
              {{ dialogData.title }}
            </h3>
          </div>
        }
        @if (dialogData.message) {
          <p
            class="text-base leading-relaxed opacity-80"
            [innerHTML]="dialogData.message"
          ></p>
        }
      </div>

      <!-- Buttons -->
      <div class="flex flex-row-reverse gap-2 pt-2">
        @for (action of dialogData.actions; track action) {
          <button
            (click)="action.action()"
            class="px-4 py-2 font-medium transition-colors"
            [class.text-blue-600]="
              !dialogData.variant || dialogData.variant === 'info'
            "
            [class.dark:text-blue-300]="
              !dialogData.variant || dialogData.variant === 'info'
            "
            [class.hover:text-blue-700]="
              !dialogData.variant || dialogData.variant === 'info'
            "
            [class.dark:hover:text-blue-200]="
              !dialogData.variant || dialogData.variant === 'info'
            "
            [class.text-green-600]="dialogData.variant === 'success'"
            [class.dark:text-green-300]="dialogData.variant === 'success'"
            [class.hover:text-green-700]="dialogData.variant === 'success'"
            [class.dark:hover:text-green-200]="dialogData.variant === 'success'"
            [class.text-red-600]="dialogData.variant === 'error'"
            [class.dark:text-red-300]="dialogData.variant === 'error'"
            [class.hover:text-red-700]="dialogData.variant === 'error'"
            [class.dark:hover:text-red-200]="dialogData.variant === 'error'"
          >
            {{ action.label }}
          </button>
        }
      </div>
    </div>
  </div>
}
